var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 229 154",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 154,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m219.57 25.616c-0-7.376-5.989-13.364-13.365-13.364h-180.41c-7.376-0-13.365 5.988-13.365 13.364v94.768c0 7.376 5.989 13.364 13.365 13.364h180.41c7.376 0 13.365-5.988 13.365-13.364v-94.768z",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "5.16px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m210 32.396c0-5.43-4.409-9.838-9.839-9.838h-168.32c-5.43-0-9.839 4.408-9.839 9.838v69.765c0 5.43 4.409 9.839 9.839 9.839h168.32c5.43-0 9.839-4.409 9.839-9.839v-69.765z",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "5.16px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m202 121c0-1.104-0.896-2-2-2h-30c-1.104 0-2 0.896-2 2v4c0 1.104 0.896 2 2 2h30c1.104 0 2-0.896 2-2v-4z",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "5.16px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m160.03 121c-0-1.104-0.896-2-2-2h-30c-1.104 0-2 0.896-2 2v4c-0 1.104 0.896 2 2 2h30c1.104 0 2-0.896 2-2v-4z",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "5.16px"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41 147 32.169-51.471 4.831-4.529-2 6c-9.158 15.194-21.061 31.69-32 50h-3z",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "5.16px"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.1e3b47cd263d3e96009fffcf213d03c5.svg";
export { ForwardRef as ReactComponent };